export default __webpack_public_path__ + "static/media/usa-star-1.5x.ca8222f6.png";